/**
 * src/admin-ui/src/pages/ModelPricing.styles.ts
 *
 * Responsive model-pricing editor styles.
 */

import { Box, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

export const PriceInput = styled(TextField)({
  minWidth: 110,
  "& input": {
    textAlign: "right",
  },
});

export const PricingCardHeader = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  gap: 8,
  alignItems: "baseline",
});

export const PriceFields = styled(Box)(({ theme }) => ({
  display: "grid",
  gap: theme.spacing(1.5),
}));
